import $ from 'jquery';

$(document).on('click', '.quantity--button', function() {
  var thisInput = $(this).parents('.quantity-container').find('.input-text.qty.text');
  var currentValue = parseFloat(thisInput.val());
  var newValue = currentValue;
  var maxValue = thisInput.attr('max');
  var minValue = thisInput.attr('min');

  var dataOperator = $(this).data('operator');

  if (dataOperator === 'plus') {
    if (maxValue) {
      if (currentValue >= maxValue) {
        newValue = currentValue;
      } else {
        newValue = currentValue + 1;
      }
    } else {
      newValue = currentValue + 1;
    }
  }

  if (dataOperator === 'minus') {
    if (minValue) {
      if (currentValue <= minValue) {
        newValue = currentValue;
      } else {
        newValue = currentValue - 1;
      }
    } else {
      newValue = currentValue - 1;
    }
  }
  thisInput.val(newValue).trigger('change');
});
